import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a03bc87231f92a993541c76fe452899f5b from "./generated-7b1ceb2c-7d34-4ce2-8eea-d57d10eadf1f.json";

import a62c6faaa6446f9f1b90a351c526a774eb from "./generated-305cd843-9328-4e8e-b319-325224d8401a.json";

import ad488285b583ad0143fda020d2a142ca8b from "./generated-89af3a7d-fd15-4237-a953-beea0e27c7ef.json";

import a77f9d5a5d5e6c1d70e7f7ddbf3252eddb from "./generated-f11083a0-522b-4511-bdd1-26236e5bf3ac.json";

import ac6a2a02528a6f41ef386fe429cb55afdb from "./generated-50c5be5d-dd90-42ac-92c3-45b4c16fc40e.json";

import a1492d2c798d8dae095cefb55175d355db from "./generated-c5244a1a-8e53-4120-850d-f25e9b971e74.json";

import a83102bf3520aab5322c5d5a32326b84db from "./generated-c836931f-1a96-4dbe-a521-10aa170551a9.json";

import a68faa22e5b2e54e6dab15a40c027b401b from "./generated-ca7adc1b-6e88-4d3d-9351-b0efb05523f0.json";

import aa0fff438a469ebc22fd335ded88eadd5b from "./generated-f4f0effe-de25-499a-8cbe-6e330d776fac.json";

import a057cba43fc520c62b9f54c95589de77eb from "./generated-bd6d95bf-d088-4605-9c42-a3fb129ff90d.json";

import a3c7b1e453276a2568d1b27ae422b6226b from "./generated-4f5d6f21-9775-4b63-9628-1f2526d806e3.json";

import a8c5c0fb91edf4fec4ba4356dc23b98f2b from "./generated-f2d1fa4e-4333-4c47-948c-42d67be5598d.json";

import a99bd711955e5c77e39f69aa061e47f1cb from "./generated-ca8117a4-cc02-455c-b14c-596463df9d72.json";

import a409d462d0132f9658110ca1ebe6c568eb from "./generated-beb72b98-c60b-4de7-92a5-03f20fdc497d.json";

import a154a530cacad61a8dcefab0218a18aa1b from "./generated-90d987a0-2bf1-4a8d-ac10-5313133ed52c.json";

import a33d8ca5a470c9a10bb845d2558820b1fb from "./generated-0b4c2256-b2bf-46cc-ae69-129fbcbe9851.json";

import a0f3e7ba65b6d31d675bd7252747d6eb4b from "./generated-82148f50-928c-4329-a97d-d8bfdf047c88.json";

import aceec0ab67eae1322f22123259fdaec09b from "./generated-d6ad1036-179e-4d41-9529-2e03e04c9496.json";

import a2f334e21fe479152888bac9d07aa5874b from "./generated-38863663-c4b0-4de1-a79d-f1b4b35ad4bb.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a03bc87231f92a993541c76fe452899f5b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a62c6faaa6446f9f1b90a351c526a774eb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ad488285b583ad0143fda020d2a142ca8b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a77f9d5a5d5e6c1d70e7f7ddbf3252eddb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ac6a2a02528a6f41ef386fe429cb55afdb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a1492d2c798d8dae095cefb55175d355db);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a83102bf3520aab5322c5d5a32326b84db);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a68faa22e5b2e54e6dab15a40c027b401b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aa0fff438a469ebc22fd335ded88eadd5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a057cba43fc520c62b9f54c95589de77eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a3c7b1e453276a2568d1b27ae422b6226b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a8c5c0fb91edf4fec4ba4356dc23b98f2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a99bd711955e5c77e39f69aa061e47f1cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a409d462d0132f9658110ca1ebe6c568eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a154a530cacad61a8dcefab0218a18aa1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a33d8ca5a470c9a10bb845d2558820b1fb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a0f3e7ba65b6d31d675bd7252747d6eb4b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aceec0ab67eae1322f22123259fdaec09b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a2f334e21fe479152888bac9d07aa5874b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a0f3e7ba65b6d31d675bd7252747d6eb4b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */